import {
  Control,
  Controller,
  FormState,
  useFieldArray,
  UseFormClearErrors,
} from "react-hook-form";
import {Button, Input, Space} from "antd";
import {DeleteOutlined, PlusCircleFilled} from "@ant-design/icons";
import {OfferingFormCheckoutFormValues} from "../../../../types";
import {FormField} from "../../../../../../../../design-system/form-field";
import {StyledCheckoutFormQuestionInputWrapper} from "../../../../style";

export function OptionList({
  nestIndex,
  control,
  formState,
  clearErrors,
}: {
  nestIndex: number;
  control: Control<OfferingFormCheckoutFormValues, any>;
  formState: FormState<OfferingFormCheckoutFormValues>;
  clearErrors: UseFormClearErrors<OfferingFormCheckoutFormValues>;
}) {
  const {fields, remove, append} = useFieldArray({
    control,
    name: `bookingQuestions.${nestIndex}.options`,
  });
  const optionError = formState.errors?.bookingQuestions?.[nestIndex]?.options?.message;
  return (
    <div>
      <Space size={16} direction="vertical" style={{display: "flex"}}>
        {fields.map((item, index) => (
          <StyledCheckoutFormQuestionInputWrapper
            style={{alignItems: "end"}}
            key={item.id}
          >
            <div className="input-wrapper">
              <FormField
                id={`serviceCheckoutFormOption-${item.id}`}
                label={`Option ${index + 1}`}
                renderInput={(id) => (
                  <Controller
                    control={control}
                    name={`bookingQuestions.${nestIndex}.options.${index}.optionLabel`}
                    render={({
                      field: {onChange, value, ref, onBlur},
                      fieldState: {error},
                    }) => (
                      <>
                        <Input
                          id={id}
                          status={error?.message ? "error" : ""}
                          onChange={onChange}
                          onBlur={onBlur}
                          size="large"
                          value={value}
                          placeholder="Enter Option"
                          ref={ref}
                        />
                        {error?.message && (
                          <div role="alert" className="ant-form-item-explain-error">
                            {error.message}
                          </div>
                        )}
                      </>
                    )}
                  />
                )}
              />
            </div>
            <div className="button-wrapper">
              <Button
                onClick={() => remove(index)}
                type="text"
                shape="circle"
                icon={<DeleteOutlined />}
                size="small"
              />
            </div>
          </StyledCheckoutFormQuestionInputWrapper>
        ))}
        {optionError && (
          <div role="alert" className="ant-form-item-explain-error">
            {optionError}
          </div>
        )}
        <div>
          <Button
            icon={<PlusCircleFilled />}
            onClick={() => {
              clearErrors(`bookingQuestions.${nestIndex}.options`);
              append({optionLabel: ""});
            }}
            size="small"
          >
            Add option
          </Button>
        </div>
      </Space>
    </div>
  );
}
